import React from 'react'

import AddIcon from 'Assets/Images/icons/add'

export const ButtonAddUnstyled = ({
  type = 'button',
  className = '',
  onClickHandler = null,
  isDisabled = false,
}) => (
  <button
    type={type}
    className={className}
    onClick={onClickHandler}
    disabled={isDisabled}
  >
    <AddIcon />
  </button>
)
